export default "__VITE_ASSET__CJoR_$ci__"